import React, {useState, useEffect, useMemo} from 'react';
import { Alert, ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/Forms/Input';
import IconButton from '../../../../../components/IconButton';
import useFormSubmit from '../../../../../hooks/useFormSubmit';
import api from '../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import { UnitsSelector } from './CreateFeeModal';
import BottomSheet from '@/components/BottomSheet';




function FeeUnitsList({ communityId, feeUnits, onUnitFeeDeleted, deleteUnitFee }){

  function confirmDeleteUnitFee(unitFee:UnitFee){
    Alert.alert('¿Eliminar la cuota de esta vivienda?', '', [
      {
        text: 'Cancelar',
        onPress: () => {},
        style: 'cancel',
      },
      { text: 'OK', onPress: () => deleteUnitFee(unitFee) },
    ]);
  }

  // function deleteUnitFee(unitFee:UnitFee){
  //   api.delete(`/communities/${communityId}/unit-fees/${unitFee.uuid}`)
  //   .then(() => {
  //     onUnitFeeDeleted?.(unitFee)
  //   })
  //   .catch(() => {})
  // }

  return (
    <View style={tw``}>
      {
        feeUnits?.map((unitFee:UnitFee, i) => {
          return (
            <View
              key={unitFee.unit?.uuid}
              style={tw.style(`row justify-between py-2 px-5`, i%2 == 0 && `bg-gray-200`)}
            >
              <Text style={tw`border-gray-600`}>{unitFee.unit?.name}</Text>

              <TouchableOpacity style={tw`py-1 px-1`} onPress={() => confirmDeleteUnitFee(unitFee)}>
                <Icon name='close' size={18} color={tw.color('red-400')} />
              </TouchableOpacity>
            </View>
          )
        })
      }
    </View>
  )
}



function AddUnitsSelector({ excludedUnits = [], communityId, onSubmit, onRequestClose }){
  const [unitsToAdd, setUnitsToAdd] = useState([]);

  return (
    <View style={tw`px-4 flex flex-1 pb-3`}>
      <View style={tw`row mb-4 `}>
        <TouchableOpacity
          style={tw`px-2 py-2 -ml-3`}
          onPress={onRequestClose}
        >
          <Icon name='chevron-left' size={18} color={tw.color('secondary')} />
        </TouchableOpacity>

        <Text style={tw`text-lg font-600 text-secondary`}>Agregar vivienda</Text>
      </View>

      <View style={tw`flex-1 mb-2`}>
        <UnitsSelector
          communityId={communityId}
          excludedUnits={excludedUnits}
          onChange={units => setUnitsToAdd(units)}
        />
      </View>

      <IconButton title={"Agregar"} style={tw`self-end`} onPress={() => onSubmit(unitsToAdd)} />
    </View>
  )
}




export default function EditFeeModal({ fee, onRequestClose, visible, onFeeEdited, communityId }) {
  const { control, handleSubmit, watch, setValue, reset } = useForm();

  const [showAddUnitsModal, setShowAddUnitsModal] = useState(false);
  const [units, setUnits] = useState([]);

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onFeeEdited,
    onError: (error) => { },
    successToastMessage: "Cuota actualizada",
    method: "put",
    endpoint: `/communities/${communityId}/fees/${fee?.fee.uuid}`,
  })


  // const snapPoints = useMemo(() => {
  //   return ['87%', "87%"]
  // }, []);
  const snapPoints = ['90%']


  useEffect(() => {
    if (visible) {
      setUnits(fee.units)
    } else {
      reset({})
      setUnits([])
    }
  }, [visible])


  useEffect(() => {
    if (fee) {
      // console.log("setting fee", JSON.stringify(fee));
      reset({})
      setUnits(fee.units)
      // setValue("units", fee.units)
      setValue("name", fee.fee.name)
      setValue("amount", fee.fee.amount?.toString())
    }
  }, [fee])



  function _submitForm(data){
    const _data = {
      ...data,
      units: feeUnitsIds,
    }

    submitForm(_data)
  }


  const feeUnitsIds = useMemo(() => {
    return units?.map((feeUnit) => feeUnit.unit.uuid)
  }, [units])



  if(!fee) return null
 

  return (
    <BottomSheet
      height={800}//! Deberia ser 90%?
      visible={visible}
      onRequestClose={onRequestClose}
      showCloseButton={true}
    >
      <View style={tw`flex-1`}>
        <View style={tw`px-5 mt-4`}>
          <Text style={tw`mb-4 text-lg font-600 text-secondary`}>Editar cuota</Text>

          <TouchableOpacity
            style={tw`absolute -top-0 right-5 items-center justify-center`}
            onPress={onRequestClose}
            >
            <Icon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>


        <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-5`}>
          <View style={tw``}>
            <Text style={tw`text-gray-500`}>Descripción</Text>

            <Input
              control={control}
              name='name'
              placeholder='ej: Arreglo de reja de entrada'
              rules={{required:true}}

            />
          </View>

          {
            fee.fee.type === "extra" &&
              <View style={tw`row justify-between mb-4`}>
                <Text style={tw`text-gray-500`}>Monto</Text>

                <View style={tw`row`}>
                  <Input
                    control={control}
                    name='amount'
                    editable={false}
                    placeholder='' style={{ container: tw`mb-0`, input: `w-50 pl-20`}}
                    rules={{required:true}}
                    keyboardType="numeric"
                  />
                  <Text style={tw`absolute left-16 text-gray-500 top-4 `}>$</Text>
                </View>
              </View>
          }


          <View style={tw`row justify-between mb-3 mt-3`}>
            <Text style={tw`text-gray-500`}>Viviendas a cobrar</Text>

            <IconButton
              title={"Agregar"}
              color='white'
              style={tw`border border-primary`}
              textColor='primary'
              onPress={() => setShowAddUnitsModal(true)}
            />
          </View>

          <View style={tw`-mx-5`}>
            <FeeUnitsList
              communityId={communityId}
              feeUnits={units} // fee.units
              deleteUnitFee={(unitFee) => {
                // console.log("deleteUnitFee", unitFee);
                setUnits(units.filter(u => u.unit.uuid !== unitFee.unit.uuid))
              }}
            />
          </View>
        </ScrollView>


        <IconButton
          title={isSubmitting ? "Guardando..." : "Guardar cuota"}
          style={tw`self-end my-5 mr-5`}
          disabled={isSubmitting}
          onPress={handleSubmit(_submitForm)}
        />
      </View>

      {
        showAddUnitsModal &&
          <View style={tw`absolute top-0 bottom-0 left-0 right-0 bg-white`}>
            <AddUnitsSelector
              communityId={communityId}
              excludedUnits={feeUnitsIds}
              onSubmit={newUnitsToAdd => {
                setShowAddUnitsModal(false)

                //! esto es un hack bien feo
                //! convierte [Units] a un [FeeUnit] improvisado :/
                // console.log("newUnitsToAdd", newUnitsToAdd);
                const _unitFeesToAdd = newUnitsToAdd.map(unit => {
                  return {
                    unit,
                  }
                })

                setUnits([...units, ..._unitFeesToAdd])
              }}
              onRequestClose={() => {
                setShowAddUnitsModal(false)
              }}
            />
          </View>
      }
    </BottomSheet>
  );
}
